import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
} from "@mui/material";

/* ===== Icons ===== */
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import SecurityIcon from "@mui/icons-material/Security";
import StorefrontIcon from "@mui/icons-material/Storefront";
import DevicesIcon from "@mui/icons-material/Devices";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";

/* ===== Industry Data ===== */
const industries = [
  {
    title: "Banking",
    icon: <AccountBalanceIcon />,
    description:
      "Digital banking platforms, secure payment systems, and scalable financial solutions enabling compliance, performance, and customer trust.",
  },
  {
    title: "Insurance",
    icon: <SecurityIcon />,
    description:
      "Policy management systems, claims automation, fraud detection, and AI-driven analytics to modernize insurance operations.",
  },
  {
    title: "Retail",
    icon: <StorefrontIcon />,
    description:
      "Omnichannel retail solutions, POS integrations, customer analytics, and inventory optimization for enhanced customer experiences.",
  },
  {
    title: "Consumer Devices",
    icon: <DevicesIcon />,
    description:
      "IoT platforms, firmware integration, cloud connectivity, and device lifecycle management for smart consumer products.",
  },
  {
    title: "Capital Markets",
    icon: <TrendingUpIcon />,
    description:
      "High-performance trading platforms, market analytics, data pipelines, and regulatory-compliant financial systems.",
  },
  {
    title: "Automobile",
    icon: <DirectionsCarIcon />,
    description:
      "Connected vehicle platforms, telematics, manufacturing intelligence, and mobility solutions for next-gen automotive firms.",
  },
  {
    title: "Manufacturing",
    icon: <PrecisionManufacturingIcon />,
    description:
      "Industry 4.0 solutions including ERP integrations, automation, predictive maintenance, and real-time production analytics.",
  },
  {
    title: "Consumer Goods",
    icon: <ShoppingCartIcon />,
    description:
      "Supply chain optimization, demand forecasting, analytics, and digital commerce solutions for global consumer brands.",
  },
];

export default function Industries() {
  return (
    <Box sx={{ backgroundColor: "#0b0f1a", color: "#fff" }}>
      {/* ===== HERO SECTION ===== */}
      <Box
        sx={{
          py: { xs: 8, md: 12 },
          textAlign: "center",
          background:
            "linear-gradient(135deg, #0b0f1a 0%, #12172a 100%)",
        }}
      >
        <Container>
          <Typography variant="h3" fontWeight={700} gutterBottom>
            Industries We Serve
          </Typography>
          <Typography
            variant="h6"
            sx={{ maxWidth: 800, mx: "auto", opacity: 0.85 }}
          >
            We partner with enterprises across industries to deliver
            innovative, scalable, and secure digital solutions that drive
            growth and operational excellence.
          </Typography>
        </Container>
      </Box>

      {/* ===== INDUSTRIES GRID ===== */}
      <Container sx={{ py: 10 }}>
        <Grid container spacing={4}>
          {industries.map((industry, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Card
                sx={{
                  height: "100%",
                  backgroundColor: "#12172a",
                  color: "#fff",
                  borderRadius: 3,
                  transition: "all 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-8px)",
                    boxShadow: "0 12px 30px rgba(255,0,128,0.25)",
                  },
                }}
              >
                <CardContent sx={{ textAlign: "center", p: 4 }}>
                  <Box
                    sx={{
                      width: 56,
                      height: 56,
                      mx: "auto",
                      mb: 2,
                      borderRadius: "50%",
                      background:
                        "linear-gradient(135deg, #ff2d8d, #ff6aa2)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: 28,
                    }}
                  >
                    {industry.icon}
                  </Box>
                  <Typography variant="h6" fontWeight={600} gutterBottom>
                    {industry.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ opacity: 0.85, lineHeight: 1.6 }}
                  >
                    {industry.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
